// extracted by mini-css-extract-plugin
export var baseButton = "_op-0";
export var controlsArrowKeys = "_op-1";
export var controlsResetButton = "_op-2";
export var lightGameButton = "_op-4 _op-0";
export var playAgainButton = "_op-5 _op-0";
export var startGameButton = "_op-3 _op-0";